
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dealers",
      function () {
        return require("private-next-pages/dealers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dealers"])
      });
    }
  